export const EVENT = {
  NONE: "none",
  NOCONF: "noconf",
  HOME: "home",
  DEVOPSCON2025: "devopscon2025",
  KUBECNCON2025: "kubecncon2025",
};

const REDIRECT = {
  SLACK: "slack",
  SITE: "site",
  GITHUB: "github",
};

export const redirectLinkMap = {
  [REDIRECT.GITHUB]: {
    label: "MDAI Labs",
    href: "https://github.com/MyDecisive/mdai-labs",
  },
  [REDIRECT.SITE]: {
    label: "MyDecisive.ai",
    href: "/",
  },
  [REDIRECT.SLACK]: {
    label: "the MDAI Slack",
    href: "https://inviter.co/mydecisivecommunity",
  },
};

export const eventInfoesMap = {
  [EVENT.DEVOPSCON2025]: { prize: "switch2", dbName: "DevOpsCon 2025" },
  [EVENT.KUBECNCON2025]: {
    prize: "switch2|amazon_gc",
    dbName: "KubeCnCon 2025",
  },
};

export const defaultEvent = EVENT.HOME;
export const defaultRedirect = REDIRECT.GITHUB;
export const eventValues = Object.values(EVENT);
export const isValidEvent = (event: string | null) =>
  event && eventValues.includes(event);
export const redirectValues = Object.values(REDIRECT);
export const isValidRedirect = (redirect: string | null) =>
  redirect && redirectValues.includes(redirect);
